// Plays a post's video in a pop-up (D-082): Brandwall's own copy (D-090: kept from collection),
// otherwise Instagram's own player, which also plays reels Instagram's API gives no file for.
import { instagramEmbedUrl } from "@brandwall/contracts";
import { useEffect, useRef, useState } from "react";

export function PlayVideo({
  post,
  label = "Play video",
}: {
  post: {
    mediaType: string;
    permalink: string | null;
    previewUrl?: string | null;
    videoUrl?: string | null;
    creator?: string;
  };
  label?: string;
}) {
  const [open, setOpen] = useState(false);
  const dialog = useRef<HTMLDialogElement>(null);
  const embed = instagramEmbedUrl(post.permalink);
  const canPlay = post.videoUrl || embed;

  useEffect(() => {
    const d = dialog.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    if (!open && d.open) d.close();
  }, [open]);

  if (post.mediaType !== "video" && post.mediaType !== "carousel") return null;
  if (!canPlay) return null;
  return (
    <>
      <button
        type="button"
        className="play-video"
        aria-label={post.mediaType === "video" ? label : "See every photo and video in this post"}
        title={post.mediaType === "video" ? label : "See the whole post"}
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        {post.mediaType === "video" ? "▶" : "⧉"}
      </button>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: a click outside closes it; Escape does the same from the keyboard */}
      <dialog
        ref={dialog}
        className="video-dialog"
        aria-label={post.creator ? `Post by @${post.creator}` : "Post"}
        onClose={() => setOpen(false)}
        onClick={(e) => {
          if (e.target === dialog.current) setOpen(false);
        }}
      >
        {open &&
          (post.videoUrl && post.mediaType === "video" ? (
            // biome-ignore lint/a11y/useMediaCaption: creators' videos come without captions
            <video
              src={post.videoUrl}
              poster={post.previewUrl ?? undefined}
              controls
              autoPlay
              playsInline
            />
          ) : (
            <iframe
              src={embed!}
              title={post.creator ? `Post by @${post.creator} on Instagram` : "Post on Instagram"}
              allow="autoplay; encrypted-media; picture-in-picture"
            />
          ))}
        <button type="button" className="btn secondary sm" onClick={() => setOpen(false)}>
          Close
        </button>
      </dialog>
    </>
  );
}
